
eval("define(\'text!orochart/js/templates/base-chart-template.html\',[],function () { return \'<div class=\"chart-container\">\\n    <div class=\"clearfix\">\\n        <div class=\"chart-content pull-left\"></div>\\n        <div class=\"chart-legend pull-left\"></div>\\n    </div>\\n</div>\\n\';});\n\n//# sourceURL=/text!orochart/js/templates/base-chart-template.html");

